<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="card card-custom gutter-b">
          <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label font-weight-bolder text-dark"
                >Business Information</span
              >
            </h3>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-12 d-flex flex-column text-dark-75">
                <span class="font-weight-bolder my-1">TIN</span>
                <span class="font-weight-bolder font-size-h5">{{
                  current.item.MetadataObject.Business.TIN
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">RDO Code</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Business.RDO
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Classification</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Business.Classification
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Business Name</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Business.BusinessName
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Registered Name</span>
                <span
                  class="opacity-70"
                  v-if="
                    current.item.MetadataObject.Business.Classification !==
                      'individual'
                  "
                  >{{
                    current.item.MetadataObject.Business.RegisteredName
                  }}</span
                >
                <span
                  class="opacity-70"
                  v-if="
                    current.item.MetadataObject.Business.Classification ===
                      'individual'
                  "
                  >{{ current.item.MetadataObject.Business.BusinessFirstName }}
                  {{ current.item.MetadataObject.Business.BusinessMiddleName }}
                  {{
                    current.item.MetadataObject.Business.BusinessLastName
                  }}</span
                >
              </div>

              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Business Address</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Business.BusinessAddress
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1"
                  >Date of Incorporation</span
                >
                <span class="opacity-70">{{
                  current.item.MetadataObject.Business.DateOfIncorporation
                    | moment("MMMM D, YYYY")
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Mobile Number</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Business.AuthorizedUser
                    .MobileNumber
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Landline</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Business.AuthorizedUser.Landline
                }}</span>
              </div>
              <div class="col-12 d-flex flex-column">
                <span class="font-weight-bolder my-1">Email Address</span>
                <span class="opacity-70">{{
                  current.item.MetadataObject.Business.AuthorizedUser
                    .EmailAddress
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8">
        <div class="card card-custom gutter-b">
          <div class="card-header border-0 py-5">
            <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
              <!--                    <span class="mr-4">-->
              <!--                      <i-->
              <!--                          class="flaticon2-writing icon-2x text-muted font-weight-bold"-->
              <!--                      ></i>-->
              <!--                    </span>-->
              <div class="d-flex flex-column text-dark-75">
                <span class="font-weight-bolder font-size-sm">ATG Number</span>
                <span class="font-weight-bolder font-size-h3">{{
                  current.item.MetadataObject.Identifier
                }}</span>
              </div>
            </div>
            <div class="card-toolbar">
              <a
                class="align-self-start btn btn-sm btn-success font-weight-bolder text-uppercase mr-3"
                href="#"
                v-if="current.item.Status === 'Approved'"
                >Download Form</a
              >
              <a
                class="align-self-start btn btn-sm btn-info font-weight-bolder text-uppercase"
                href="#"
                >Add Comment</a
              >
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="d-flex">
              <div class="flex-grow-1">
                <div class="separator separator-solid mb-7"></div>
                <div class="d-flex align-items-center flex-wrap">
                  <!--                  <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">-->
                  <!--                    <span class="mr-4">-->
                  <!--                      <i-->
                  <!--                        class="flaticon2-writing icon-2x text-muted font-weight-bold"-->
                  <!--                      ></i>-->
                  <!--                    </span>-->
                  <!--                    <div class="d-flex flex-column text-dark-75">-->
                  <!--                      <span class="font-weight-bolder font-size-sm">OCN</span>-->
                  <!--                      <span class="font-weight-bolder font-size-h5">{{-->
                  <!--                        current.item.MetadataObject.Identifier-->
                  <!--                      }}</span>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
                    <span class="mr-4">
                      <i
                        class="flaticon2-calendar-9 icon-2x text-muted font-weight-bold"
                      ></i>
                    </span>
                    <div class="d-flex flex-column text-dark-75">
                      <span class="font-weight-bolder font-size-sm"
                        >Submission Date</span
                      >
                      <span class="font-weight-bolder font-size-h5">{{
                        current.item.CreatedDateTime | moment("MMMM D YYYY")
                      }}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
                    <span class="mr-4">
                      <i
                        class="flaticon-globe icon-2x text-muted font-weight-bold"
                      ></i>
                    </span>
                    <div class="d-flex flex-column text-dark-75">
                      <span class="font-weight-bolder font-size-sm"
                        >Status</span
                      >
                      <span class="font-weight-bolder font-size-h5">{{
                        current.item.Status
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center flex-lg-fill mr-5 my-1"
                    v-if="current.item.Status !== 'ForReview'"
                  >
                    <span class="mr-4">
                      <i
                        class="fas fa-sort-numeric-down icon-2x text-muted font-weight-bold"
                      ></i>
                    </span>
                    <div class="d-flex flex-column text-dark-75">
                      <span class="font-weight-bolder font-size-sm"
                        >Series Number</span
                      >
                      <span class="font-weight-bolder font-size-h5"
                        >00001 - 99999</span
                      >
                    </div>
                  </div>
                </div>
                <div class="separator separator-solid my-7"></div>
                <div>
                  <div class="d-flex justify-content-between">
                    <div class="d-flex flex-column flex-root">
                      <span class="font-weight-bolder mb-1"
                        >E-Receipt TSP Name</span
                      >
                      <span class="opacity-70">{{
                        current.item.MetadataObject.Application.ProviderName
                      }}</span>
                    </div>
                    <div class="d-flex flex-column flex-root">
                      <span class="font-weight-bolder mb-1"
                        >E-Receipt TSP TIN</span
                      >
                      <span class="opacity-70">{{
                        current.item.MetadataObject.Application.ProviderName
                      }}</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between pt-6">
                    <div class="d-flex flex-column flex-root">
                      <span class="font-weight-bolder mb-1"
                        >E-Receipt TSP Accreditation Number</span
                      >
                      <span class="opacity-70">{{
                        current.item.MetadataObject.Application
                          .ProviderAccreditationNumber
                      }}</span>
                    </div>
                    <div class="d-flex flex-column flex-root">
                      <span class="font-weight-bolder mb-1"
                        >Date of Accreditation</span
                      >
                      <span class="opacity-70">{{
                        current.item.MetadataObject.Application
                          .ProviderDateOfIncorporation | moment("MMMM D YYYY")
                      }}</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between pt-6">
                    <div class="d-flex flex-column flex-root">
                      <span class="font-weight-bolder mb-1"
                        >E-Receipt TSP Business Address</span
                      >
                      <span class="opacity-70">{{
                        current.item.MetadataObject.Application.ProviderAddress
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";

Vue.use(require("vue-moment"));
export default {
  components: {},
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isBusy: false,
      tabIndex: 0,
      current: {
        item: null
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setBreadcrumbs("10G7U20809");
      this.getData(this.id)
        .then(data => {
          this.setBreadcrumbs(data.Identifier);
        })
        .catch();
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Authority to Generate",
          route: "/easyreceipt"
        },
        {
          title: "ATG Applications",
          route: "/easyreceipt/applications"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    getData(id) {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = { Id: id };
        ApiService.get("easyreceipt/getbyid", param)
          .then(({ data }) => {
            this.$gtag.event("atg_getbyid", param);
            self.current.item = data;
            self.isBusy = false;
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    }
  },
  watch: {}
};
</script>
